import React, {Component} from 'react';
import SubmitInput from '../Fields/SubmitInput';
import TenantRow from '../Fragments/TenantRow';
import { browserHistory } from 'react-router';
import FullPageSpinner from '../Fragments/FullPageSpinner';

let Quote = require('../Managers/Quote');
let HttpService = require('../Managers/HttpService');
const moment = require('moment');

export default class CaseSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantNumber: 1,
            isTenantDetailsModalVisible: false,
            isLandlordDetailsModalVisible: false,
            isFinancialDetailsModalVisible: false,
            tenantWarningModal: 0,
            tenantsArray: [],
            isFullPageSpinnerActive: false,
            totalProvidedRentAmount: 0,
            isAdjustedTotalRentConstraintViolation: false,
        };
    }

    componentWillMount() {
        this.sumRentShares();

        let tenantArray = [];

        for (let index = 1; index <= parseInt(Quote.getByPath('Case', 'numberOfTenants')); index++) {
            tenantArray.push(
                <TenantRow
                    key={index}
                    currentNumber={index}
                    defaultShare={0}
                    fieldName={'tenant_' + index}
                    updateTenantRentShare={this.sumRentShares.bind(this)}
                    removeTenant={this.removeTenant.bind(this)}
                />
            );
        }

        this.setState({ tenantsArray: tenantArray });
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    /**
     * Works out the total provided rent amount across all tenant applications
     * in order to set the state for showing or hiding the rental amount
     * constraint (if the total rent shares are higher OR lower than the
     * property rent amount) warning message.
     *
     * @returns {Promise.<TResult>}
     */
    sumRentShares() {
        return new Promise((resolve) => {
            // First reset the provided total to zero to stop any potential
            // addition errors.
            resolve(this.setState({ totalProvidedRentAmount: 0 }));
        })
        .then(() => {
            // Then loop through the tenants object we have and add their
            // rentShare values to the totalProvidedRentAmount state.
            for (let index = 1; index <= parseInt(Quote.getByPath('Case', 'numberOfTenants')); index++) {
                this.setState({ totalProvidedRentAmount: parseFloat(this.state.totalProvidedRentAmount) + parseFloat(Quote.getByPath('BaseIndividualApplication_' + index, 'rentShare')) });
            }
        })
        .then(() => {
            // Then toggle the isAdjustedTotalRentConstraintViolation state
            // (to show or hide the warning message), based on the combined
            // rentAmount vs. the totalRent on the property.
            this.setState({ isAdjustedTotalRentConstraintViolation: parseFloat(this.state.totalProvidedRentAmount) !== parseFloat(Quote.getByPath('Case', 'totalRent')) ? true : false });
        });
    }

    /**
     * Trigger a warning message for deleting a tenant of a given index
     *
     * @param i
     */
    removeTenant(i) {
        this.setState({ tenantWarningModal: i });
    }

    /**
     * store all the current base individual applications,
     * delete them all, then reindex to have the new correct
     * index.
     *
     * also rebuild the components array to reflect the new source
     * @return {void}
     */
    rebaseBaseIndividualApplications() {
        let applications = [];
        for (let i = 1; i <= 10; i++) {
            i = String(i);
            if (window.localStorage.getItem('BaseIndividualApplication_' + i)) {
                applications.push(window.localStorage.getItem('BaseIndividualApplication_' + i));
                window.localStorage.removeItem('BaseIndividualApplication_' + i);
            }
        }

        applications.map((app, i) => {
            let appObject = JSON.parse(app);
            // this if gets rid of any apps that are only a completion method
            if (!window.uorn(app) && !window.uorn(appObject) && !window.uorn(appObject.firstName)) {
                window.localStorage.setItem('BaseIndividualApplication_' + String(i + 1), app);
            }
        });

        this.sumRentShares();

        let tarray = [];

        applications.map((app, i) => {
            i++;
            app = JSON.parse(app);
            tarray.push(
                <TenantRow
                    key={app.email + String(i)}
                    currentNumber={i}
                    defaultShare={0}
                    fieldName={'tenant_' + i}
                    updateTenantRentShare={this.sumRentShares.bind(this)}
                    removeTenant={this.removeTenant.bind(this)}
                />
            );
        });

        this.setState({
            tenantsArray: tarray
        });
    }

    /**
     * Deletes the tenant from localStorage, updates the provided rent amount
     * against the total rent amount for the property, closes the warning modal,
     * then updates the tenantArray used to render out the tenant summaries.
     *
     * @param i
     */
    confirmRemoveTenant(i) {
        let numberOfTenants = Quote.getByPath('Case', 'numberOfTenants');
        new Promise((resolve) => {
            window.localStorage.removeItem('BaseIndividualApplication_' + String(i));
            resolve(true);
        })
        .then(() => {
            this.setState({ tenantWarningModal: 0 });
            Quote.setByPath('Case.numberOfTenants', (numberOfTenants - 1));
        })
        .then(() => {
            this.rebaseBaseIndividualApplications();
        });
    }

    /**
     * Does the action of saving all applicants against this application. This
     * is progressively done as the user fills in details for each applicant,
     * but the rental amounts may be changed on this step, so we re-send the
     * localStorage values.
     */
    completeCase() {
        this.setState({ isFullPageSpinnerActive: true }, () => {
            HttpService.agentGeneralisedSubmitProcess(() => {
                this.setState({ isFullPageSpinnerActive: false });
                window.localStorage.removeItem('validationError');
                browserHistory.push('/case/submitted');
            }, (invalidData) => {
                window.localStorage.setItem('validationError', JSON.stringify(invalidData));
                browserHistory.push('/error/agent-submission');
            });
        });
    }

    /**
     * Returns the human-friendly property type name based on the ID passed.
     */
    getPropertyTypeName(v) {
        switch (v) {
            case 1:
                return 'Detached';
            case 2:
                return 'Semi-detached';
            case 3:
                return 'Flat';
            case 4:
                return 'Terraced';
            case 5:
                return 'Bungalow';
            default:
                return 'Unknown';
        }
    }

    /**
     * Close modals on the page.
     *
     * @param e
     */
    closeModals(e) {
        e.preventDefault();
        this.setState({ tenantWarningModal: 0 });
    }

    /**
     * Takes an address object and formats the values into an array then returns
     * it.
     */
    returnAddress(v) {
        let addressArray = [];

        v.flat ? addressArray.push(v.flat) : null;
        v.houseName ? addressArray.push(v.houseName) : null;
        v.houseNumber ? addressArray.push(v.houseNumber) : null;
        v.street ? addressArray.push(v.street) : null;
        v.locality ? addressArray.push(v.locality) : null;
        v.district ? addressArray.push(v.district) : null;
        v.town ? addressArray.push(v.town) : null;
        v.county ? addressArray.push(v.county) : null;
        v.country ? addressArray.push(v.country) : null;
        v.postcode ? addressArray.push(v.postcode) : null;

        return addressArray.join(', ');
    }

    render() {
        let address = this.returnAddress(Quote.get('address', 'Case'));
        let FaCross = require('react-icons/lib/fa/close');

        return(
            <div>
                <question-row class="header-row">
                    <h1>Summary</h1>
                    <p>Here you can review all of the details about your property to let, as well as all of the prospective tenants you have added to the application ready to be referenced.</p>
                </question-row>

                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                <question-row>
                    <div className="question-main">
                        <h2>Property to be let</h2>
                        {address ? <p><strong>Address: {address}</strong></p> : null}
                        <p><strong>Property type: {this.getPropertyTypeName(Quote.get('propertyType', 'Case'))}</strong></p>
                        <p><strong>Number of bedrooms: {Quote.get('numberOfBedrooms', 'Case')}</strong></p>
                        <p><strong>Tenancy start: {moment(Quote.get('tenancyStartDate', 'Case')).format('DD-MM-YYYY')}</strong></p>
                        <p><strong>Tenancy term: {Quote.get('tenancyTerm', 'Case')} months</strong></p>
                        <p><strong>Property rent: &pound;{Quote.get('totalRent', 'Case')}</strong></p>
                    </div>
                </question-row>

                {/* Summary of tenants */}
                <div className="summary-container">
                    {this.state.tenantsArray}
                </div>

                {this.state.isAdjustedTotalRentConstraintViolation === true ?
                    <question-row class="no-border">
                        <div className="question-main">
                            <div className="supplemental-bubble">
                                <div className="arrow" />
                                <p>Please note that the rent share(s) that you have entered for the tenant(s) does not match the total rent for the property. Although you may continue without amending, this may invalidate any future rent protection.</p>
                            </div>
                        </div>
                    </question-row>
                : null}

                <div className={this.state.tenantWarningModal !== 0 ? 'modal-container modal-active' : 'modal-container'}>
                    <div className="modal medium-width has-footer">
                        <div className="modal-header">
                            Deleting {Quote.get('firstName', 'BaseIndividualApplication_' + this.state.tenantWarningModal)} {Quote.get('lastName', 'BaseIndividualApplication_' + this.state.tenantWarningModal)}
                            <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                <FaCross className="pointer" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="content">
                                <p><b>Please note:</b> you cannot undo this action.</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <a
                                id="saveAddressChanges"
                                className="btn btn-warning pull-left"
                                onClick={() => this.confirmRemoveTenant(this.state.tenantWarningModal)}
                            >Delete</a>
                            <a
                                id="cancelAddressChanges"
                                className="btn btn-default pull-right"
                                onClick={this.closeModals.bind(this)}
                            >Cancel</a>
                            <div className="clearfix" />
                        </div>
                    </div>
                </div>

                <SubmitInput
                    label="Submit for Referencing"
                    callbackFunction={this.completeCase.bind(this)}
                    backLink={false}
                    saveForLater={false}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/CaseSummary.js